import type { Account, ClientPerson } from './api';

/**
 * Several people sign in for one client (2026-10-11): the company's own sign-in
 * and each contact given one. These name them the way the portal shows them.
 */

/** The client's company name, in the reader's language. */
export function companyName(account: Account | null, locale: string): string {
  if (!account) return '';
  return locale === 'ar' && account.client.companyNameAr ? account.client.companyNameAr : account.client.companyName;
}

/** Whoever is signed in: the contact's name, or the company's for its own sign-in. */
export function signedInName(account: Account | null, locale: string): string {
  return account?.contact?.name ?? companyName(account, locale);
}

/** Who of the client's people did something: `you`, the contact's name, or the company's name. */
export function clientPersonName(person: ClientPerson, company: string, you: string): string {
  if (person.you) return you;
  return person.name ?? company;
}
